import { createElementBlock as c, openBlock as e, createStaticVNode as t } from "vue";
import "./SectionFlare.vue2.js";
import i from "../../_virtual/_plugin-vue_export-helper.js";
const s = {}, d = { class: "section-flare" };
function o(v, a) {
  return e(), c("div", d, a[0] || (a[0] = [
    t('<div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div><div class="section-flare-item" data-v-2a9c8c02></div>', 8)
  ]));
}
const f = /* @__PURE__ */ i(s, [["render", o], ["__scopeId", "data-v-2a9c8c02"]]);
export {
  f as default
};
